import ServiceBase from './ServiceBase';

export default class PartnerService extends ServiceBase {

    getPartners() {
        return this.request('get', 'partners/getPartners');
    }
}
